import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'

export default function ForbiddenPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-[#121214] text-[#F5F3EF] px-4 py-20">
      <SeoHead
        title="403 - Adgang nægtet - JARCon ApS"
        description="Du har ikke adgang til denne ressource hos JARCon ApS."
      />

      <div className="max-w-lg text-center space-y-6">
        <div className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-[#18181C] border border-[#C87D46]/40 text-[#C87D46] shadow-xl mb-2">
          <i className="fa-solid fa-lock text-3xl" aria-hidden="true" />
        </div>

        <div className="text-xs uppercase tracking-widest text-[#C87D46] font-medium">
          Fejlkode 403 · Adgang forbudt
        </div>

        <h1 className="font-serif text-4xl sm:text-5xl text-[#F5F3EF]">
          Adgang nægtet
        </h1>

        <p className="text-sm sm:text-base text-[#A8A49C] leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side eller ressource. Du kan vende tilbage til det offentlige HiFi-univers eller kontakte os direkte.
        </p>

        <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-sm bg-[#C87D46] px-6 py-3 text-xs font-medium text-white hover:bg-[#D98E58] transition-colors"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 rounded-sm border border-white/20 bg-[#18181C] px-6 py-3 text-xs font-medium text-[#F5F3EF] hover:bg-white/10 transition-colors"
          >
            <i className="fa-solid fa-envelope text-xs text-[#C87D46]" aria-hidden="true" />
            <span>Kontakt JARCon</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
